export const NumberFormat = ({
  num,
  currency = "WON",
}: {
  num: number;
  currency?: string;
}) => {
  // const num = parseInt(value);
  return (
    <span>
      {currency === "WON" ? "₩" : "$"}
      {num.toLocaleString()}
    </span>
  );
};
